import { useState, useEffect } from 'react';
import useProductPanel from '../../../../hooks/productpanel/useProductPanel';
import { useSale } from '../../../../hooks/sale/useSale';
import InputField from '../../../Forms/Input/InputField';
import CategoryButtonSelectable from './CategoryButtonSelectable';
import FormModal from '../../../Modals/FormModal';

interface CategoryModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CategoryModal = ({ isOpen, onClose }: CategoryModalProps) => {
  const [search, setSearch] = useState('');

  const {
    categories,
    fetchCategories,
    fetchFilteredProducts,
    pageSize,
    selectedCategoryId,
    setSelectedCategory,
  } = useProductPanel();

  const { form } = useSale();
  const isSaleInitialized = !!form?.id;

  // 🔄 Cargar categorías solo si la venta está inicializada
  useEffect(() => {
    if (isSaleInitialized && categories.length === 0) {
      fetchCategories();
    }
  }, [isSaleInitialized]);

  const filteredCategories = categories.filter((cat) =>
    cat.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleApply = () => {
    if (selectedCategoryId !== null) {
      fetchFilteredProducts({ categoryId: selectedCategoryId }, 0, pageSize);
    }
    onClose();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Seleccionar Categoría"
      maxWidth="max-w-3xl"
      overlayBg="dark"
    >
      {/* 🔍 BUSCADOR */}
      <InputField
        label="Buscar categoría"
        name="search"
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Buscar categoría..."
        iconKey="search"
      />

      {/* 🧱 LISTADO DE CATEGORÍAS */}
      <div
        className="
    my-5 max-h-[350px] overflow-y-auto 
    rounded-lg border border-slate-200/70 
    bg-gradient-to-b from-slate-50 to-slate-100
    p-4 shadow-sm 
    transition-all duration-200
    dark:border-strokedark dark:bg-boxdark/70 dark:from-boxdark dark:to-boxdark/80
  "
      >
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2">
          {filteredCategories.length > 0 ? (
            filteredCategories.map((cat) => (
              <CategoryButtonSelectable
                key={cat.id}
                id={cat.id}
                name={cat.name}
                isSelected={selectedCategoryId === cat.id}
                onClick={setSelectedCategory}
                iconName="category"
              />
            ))
          ) : (
            <p className="col-span-full py-8 text-center text-sm italic text-slate-400">
              No se encontraron categorías.
            </p>
          )}
        </div>
      </div>

      {/* ⚙️ BOTONES DE ACCIÓN */}
      <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button
          onClick={onClose}
          className="rounded-md bg-[#DC3545] px-6 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-opacity-90"
        >
          Cancelar
        </button>
        <button
          onClick={handleApply}
          className="rounded-md bg-primary px-6 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-opacity-90"
        >
          Aplicar Categoría
        </button>
      </div>
    </FormModal>
  );
};

export default CategoryModal;
